
import React, { useState, useEffect, useRef } from 'react'
import '../../home-style.scss'
import { fetchGraphV2aggr } from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import useYieldgraphStyles from './styles'
import YieldGraphFilter from '../YieldGraphFilter/YieldGraphFilter'
import YieldGraphContainer from '../YieldGraphContainer/YieldGraphContainer'

const Yieldgraph = ({ token }) => {
  const classes = useYieldgraphStyles()
  const [technicalFromDate, setTechnicalFromDate] = useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = useState(dayjs(new Date()))
  const [graphDuration, setGraphDuration] = useState('1m')
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [selectedButtons, setSelectedButtons] = useState(['GTI'])
  const [mapInverterSeries, setMapInverterSeries] = useState([])
  const [inverterviewbutton, setInverterViewButton] = useState('1m')
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [isData, setIsData] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [dataLoaded, setDataLoaded] = useState(false) // Add flag to track if data has been successfully loaded

  const chartRef = useRef(null)

  console.log("TOKEN 🔵📘", token);

  // Base chart options - improved tooltip and formatting
  const [lineData, setLineData] = useState({
    options: {
      chart: {
        height: 350,
        type: 'bar',
        zoom: { enabled: true },
        toolbar: {
          export: {
            csv: {
              filename: 'SpecificYield',
              headerCategory: 'Date',
              headerValue: 'value',
            },
            svg: { filename: 'SpecificYield' },
            png: { filename: 'SpecificYield' },
          },
        },
        // Add animations for better UX
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '70%',
          endingShape: 'rounded',
        },
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
      },
      dataLabels: { enabled: false },
      stroke: {
        width: 0,
      },
      title: { align: 'left' },
      markers: {
        size: 0,
      },
      grid: { row: { colors: ['#f3f3f3', 'transparent'], opacity: 0.5 } },
      xaxis: {
        type: 'category',
        tickAmount: 15,
        tickPlacement: 'on',
        labels: {
          rotate: -45,
          hideOverlappingLabels: true,
          showDuplicates: false,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
          },
          formatter: function (value) {
            // Enhanced date validation and formatting
            if (!value) return ''
            try {
              if (value.length === 7) {
                return dayjs(value).isValid()
                  ? dayjs(value).format('MMM YYYY')
                  : value
              } else {
                return dayjs(value).isValid()
                  ? dayjs(value).format('DD-MM')
                  : value
              }
            } catch (e) {
              return value
            }
          },
        },
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        x: {
          show: true,
          formatter: function (value, opts) {
            try {
              const date =
                opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
                  .x
              if (!date) return 'Invalid date'

              if (dayjs(date).isValid()) {
                return date.length === 7
                  ? dayjs(date).format('MMMM YYYY')
                  : dayjs(date).format('DD-MMMM-YYYY')
              }
              return date
            } catch (e) {
              return 'Invalid date'
            }
          },
        },
        y: {
          formatter: function (value) {
            return parseFloat(value).toFixed(1) + ' Yield'
          },
        },
      },
      yaxis: {
        title: {
          text: 'Yield (%)',
          style: {
            fontSize: '14px',
            fontWeight: 500,
          },
        },
        labels: {
          formatter: function (value) {
            return parseFloat(value).toFixed(1)
          },
        },
      },
    },
  })

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setIsLoading(true)
        const success = await fetchData('GTI', '1m', technicalFromDate)
        if (success) {
          setDataLoaded(true)
        } else {
          setTimeout(async () => {
            await fetchData('GTI', '1m', technicalFromDate)
            setDataLoaded(true)
          }, 1000)
        }
      } catch (error) {
        console.error('Failed to load initial data:', error)
        setError('Failed to load initial data. Please try refreshing the page.')
      }
    }

    loadInitialData()
  }, [])


  const processYieldData = (data, type) => {
    // Ensure we have a valid response with data
    if (!data || !data.success) {
      console.warn(`No ${type} data available`);
      return [];
    }
  
    // Choose the correct data array based on type
    const dataArray = type === 'Yield' ? data.total_pr : data.gti_data;
  
    // Filter and transform the data
    return dataArray
      .filter(item => {
        // Customize filtering based on data type
        if (type === 'Yield') {
          return item.totalEnergy > 0 && 
                 item.totalCapacity > 0 && 
                 item.aggregatedYield > 0 && item.aggregatedYield <100;
        } else if (type === 'GTI') {
          return item.totalGti > 0 && 
                 item.plantCount > 0;
        }
        return false;
      })
      .map(item => ({
        period: item.period,
        value: type === 'Yield' ? item.aggregatedYield : item.totalGti,
        totalEnergy: item.totalEnergy || 0,
        totalCapacity: item.totalCapacity || 0,
        plantCount: item.plantCount || 0
      }));
  };
  
  /*const fetchData = async (type, duration, fromDate) => {
    try {
      setIsLoading(true);
      setError(null);
  
      // Prepare date parameters (existing logic)
      let TechnicalFromDate = prepareDateForFetch(duration, fromDate);
      const TechnicalToDate = dayjs().format('YYYY-MM-DD');
  
      // Fetch data
      const resp = await FetchAggregatedYieldAndGti(
        TechnicalFromDate,
        duration,
        type.toLowerCase(),
        token,
        TechnicalToDate
      );
  
      // Process the data
      if (resp?.data?.success) {
        const processedData = processYieldData(resp.data, type);
  
        // Prepare series for chart
        const newSeries = {
          name: type,
          data: processedData.map(item => ({
            x: item.period,
            y: item.value
          })),
          color: type === 'GTI' ? '#6CB759' : '#5968B7'
        };
  
        // Update state
        setMapInverterSeries(prevSeries => {
          // Remove existing series with the same name
          const filteredSeries = prevSeries.filter(
            series => series.name !== type
          );
          return [...filteredSeries, newSeries];
        });
  
        setIsData(processedData.length > 0);
        return true;
      } else {
        setError(`No ${type} data available`);
        return false;
      }
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error);
      setError(`Failed to fetch ${type} data: ${error.message}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const prepareDateForFetch = (duration, fromDate) => {
    switch (duration) {
      case '1m':
        return dayjs().subtract(29, 'day').format('YYYY-MM-DD');
      case '3m':
        return dayjs().subtract(3, 'month').format('YYYY-MM-DD');
      case '6m':
        return dayjs().subtract(6, 'month').format('YYYY-MM-DD');
      case 'year':
        return dayjs().subtract(1, 'year').format('YYYY-MM-DD');
      case 'mtd':
        return dayjs().startOf('month').format('YYYY-MM-DD');
      case 'ytd':
        return dayjs().startOf('year').format('YYYY-MM-DD');
      case 'custom':
        return dayjs(fromDate).format('YYYY-MM-DD');
      default:
        return dayjs().subtract(29, 'day').format('YYYY-MM-DD');
    }
  };*/

  //for graph-v2 
  const fetchData = async (type, duration, fromDate) => {
    try {
      setIsLoading(true);
      setError(null);

      let apiDataType;
      switch(type) {
        case 'Yield':
          apiDataType = 'specificyield';
          break;
        case 'GTI':
          apiDataType = 'gti';
          break;
        default:
          apiDataType = type.toLowerCase();
      }

      let apiDuration;
      switch (duration) {
        case '1m':
          apiDuration = '1m';
          break;
        case '3m':
          apiDuration = '3m';
          break;
        case '6m':
          apiDuration = '6m';
          break;
        case 'year':
          apiDuration = '1y';
          break;
        case 'ytd':
          apiDuration = 'ytd';
          break;
        case 'custom':
          apiDuration = 'custom';
          break;
        case 'mtd':
          apiDuration = 'mtd';
          break;
        default:
          apiDuration = '1m';
      }
      
      const todaydate = duration === 'custom' ? fromDate : dayjs(new Date());
      const fromDateFormatted = todaydate.format('YYYY-MM-DD');
      console.log("FROMDATEFORMATTED for", type, ":", fromDateFormatted);
      
      //todate is all for everything except custom periods
      const toDateParam = duration === 'custom' 
        ? technicalToDate.format('YYYY-MM-DD') 
        : 'all';

      const data = await fetchGraphV2aggr(
        apiDataType,
        fromDateFormatted,
        apiDuration,
        token,
        toDateParam
      );
      
      const processedData = data.map(item => ({
        x: item.x,
        y: item.y
      }));

      const newSeries = {
        name: type,
        data: processedData,
        color: type === 'GTI' ? '#6CB759' : '#5968B7'
      };

      setMapInverterSeries(prevSeries => {
        //Remove existing series with the same name
        const filteredSeries = prevSeries.filter(
          series => series.name !== type
        );
        return [...filteredSeries, newSeries];
      });

      setIsData(processedData.length > 0);
      return true;
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error);
      setError(`Failed to fetch ${type} data: ${error.message}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handleChangePreiod()
    }, 300) // Add debounce

    return () => {
      clearTimeout(handler)
    }
  }, [technicalFromDate, technicalToDate])

  const handleGraphupdateOptions = (newOptions) => {
    setLineData((prevOptions) => ({
      ...prevOptions,
      options: {
        ...prevOptions.options,
        xaxis: newOptions.xaxis,
        tooltip: newOptions.tooltip,
      },
    }))
  }

  const handleChangePreiod = () => {
    if (selectedButtons.length > 0) {
      setIsLoading(true)
      setError(null)
      const fetchPromises = selectedButtons.map((type) =>
        fetchData(type, inverterviewbutton, technicalFromDate)
      )

      Promise.all(fetchPromises)
        .then(() => {
          // All data fetched successfully
          setDataLoaded(true)
        })
        .catch((error) => {
          console.error('Error fetching data:', error)
          setError('Failed to update data. Please try again.')
        })
    } else {
      setIsData(false)
      setMapInverterSeries([])
    }
  }

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleChooseDate = (value, type) => {
    if (!value) return

    let subtraction, subType
    switch (graphDuration) {
      case 'year':
        subtraction = 11
        subType = 'month'
        break
      case '1m':
        subtraction = 29
        subType = 'day'
        break
      case '3m':
        subtraction = 2
        subType = 'month'
        break
      case '6m':
        subtraction = 5
        subType = 'month'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        break
      default:
        break
    }

    if (type === 'from') {
      if (inverterviewbutton === 'custom') {
        setTechnicalFromDate(value)
      } else {
        const yearData = dayjs(value).add(subtraction, subType)
        setTechnicalFromDate(value)
        const currentDate = dayjs()
        if (yearData.isAfter(currentDate)) {
          setTechnicalFromDate(dayjs(new Date()).subtract(subtraction, subType))
          setTechnicalToDate(dayjs(new Date()))
        } else {
          setTechnicalToDate(dayjs(new Date()))
        }
      }
    } else if (type === 'to') {
      if (inverterviewbutton === 'custom') {
        setTechnicalToDate(value)
      } else {
        setTechnicalFromDate(dayjs(value).subtract(subtraction, subType))
        setTechnicalToDate(dayjs(new Date()))
      }
    }
  }

  const handleSelectYearWIthDate = (type, duration, UpdatedDate) => {
    setGraphDuration(duration)
    setInverterViewButton(duration)
    fetchData(type, duration, UpdatedDate)
  }

  const handleButtonClick = (buttonName) => {
    if (selectedButtons.includes(`${buttonName}`)) {
      setSelectedButtons(
        selectedButtons.filter((btn) => btn !== `${buttonName}`)
      )
      setMapInverterSeries((prevSeries) =>
        prevSeries.filter((obj) => obj.name !== `${buttonName}`)
      )

      if (selectedButtons.length === 1) {
        setIsData(false)
      }
    } else {
      setSelectedButtons([...selectedButtons, `${buttonName}`])
      let devtype = buttonName === 'GTI' ? 'GTI' : 'Yield'
      fetchData(devtype, inverterviewbutton, technicalFromDate)
    }
  }

  const dynamicHeadings = mapInverterSeries.map((item) => item.name)
  const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

  return (
    <div className={classes.root}>
      <div
        className="graph_bg"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <YieldGraphFilter
          isButtonSelected={isButtonSelected}
          handleButtonClick={handleButtonClick}
          setOpenTable={setOpenTable}
          handleChooseDate={handleChooseDate}
          technicalToDate={technicalToDate}
          technicalFromDate={technicalFromDate}
          handleOpen={handleOpen}
          openTable={openTable}
          mapInverterSeries={mapInverterSeries}
          graphDuration={graphDuration}
          setTechnicalFromDate={setTechnicalFromDate}
          setTechnicalToDate={setTechnicalToDate}
          setinverterviewbutton={setInverterViewButton}
          inverterviewbutton={inverterviewbutton}
          selectedButtons={selectedButtons}
          handleSelectYearWIthDate={handleSelectYearWIthDate}
          chartRef={chartRef}
          handleGraphupdateOptions={handleGraphupdateOptions}
          isLoading={isLoading}
        />

        {error && (
          <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <YieldGraphContainer
          height={380}
          selectedButtons={selectedButtons}
          tableStyle={true}
          dynamicHeadings={dynamicHeadings}
          mapInverterSeries={mapInverterSeries}
          lineData={lineData}
          chartRef={chartRef}
          openTable={openTable}
          isData={isData && !isLoading && dataLoaded} // FIXED: Add dataLoaded flag
          isLoading={isLoading}
        />
      </div>

      <Dialog fullScreen open={open} onClose={handleClose}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="graph_bg">
              <YieldGraphFilter
                isButtonSelected={isButtonSelected}
                handleButtonClick={handleButtonClick}
                setOpenTable={setOpenTable}
                handleChooseDate={handleChooseDate}
                technicalToDate={technicalToDate}
                technicalFromDate={technicalFromDate}
                handleOpen={handleOpen}
                openTable={openTable}
                mapInverterSeries={mapInverterSeries}
                graphDuration={graphDuration}
                setTechnicalFromDate={setTechnicalFromDate}
                setTechnicalToDate={setTechnicalToDate}
                setinverterviewbutton={setInverterViewButton}
                inverterviewbutton={inverterviewbutton}
                selectedButtons={selectedButtons}
                handleSelectYearWIthDate={handleSelectYearWIthDate}
                chartRef={chartRef}
                handleGraphupdateOptions={handleGraphupdateOptions}
                isLoading={isLoading}
              />

              {error && (
                <div
                  style={{ padding: '20px', color: 'red', textAlign: 'center' }}
                >
                  {error}
                </div>
              )}

              <YieldGraphContainer
                height={screenHeight - 200}
                selectedButtons={selectedButtons}
                tableStyle={false}
                dynamicHeadings={dynamicHeadings}
                mapInverterSeries={mapInverterSeries}
                lineData={lineData}
                chartRef={chartRef}
                openTable={openTable}
                isData={isData && !isLoading && dataLoaded} // FIXED: Add dataLoaded flag
                isLoading={isLoading}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Yieldgraph
